import React from 'react';
import { COLORS, FONT_SIZE, RADII, SPACE } from '../theme';

export interface InputHintProps {
  label: string;
  device: 'keyboard' | 'gamepad';
  title?: string;
  testId?: string;
  /** `parchment`: inked for the tome pages (NPC text keys); `hud` (default): the dark HUD chip. */
  variant?: 'hud' | 'parchment';
}

const PARCHMENT: React.CSSProperties = {
  minWidth: 22,
  padding: '0 6px',
  background: 'linear-gradient(#fffaf0, #efe2c4)',
  border: '1px solid rgba(120, 84, 30, 0.55)',
  borderBottomWidth: 2,
  borderRadius: 5,
  color: '#3a2a12',
  fontSize: 12,
  fontStyle: 'normal',
  lineHeight: 1.45,
  verticalAlign: 'baseline',
};

/** Compact visual-only shortcut chip for keyboard and controller actions. */
export const InputHint: React.FC<InputHintProps> = ({
  label,
  device,
  title,
  testId,
  variant = 'hud',
}) => (
  <kbd
    aria-hidden="true"
    data-device={device}
    data-variant={variant}
    data-testid={testId}
    title={title ?? `${device === 'gamepad' ? 'Controller' : 'Keyboard'} shortcut`}
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: device === 'gamepad' ? 30 : 18,
      padding: `1px ${SPACE.xs}px`,
      background: COLORS.surfaceSunken,
      border: `1px solid ${device === 'gamepad' ? COLORS.info : COLORS.borderSubtle}`,
      borderRadius: RADII.sm,
      color: device === 'gamepad' ? COLORS.info : COLORS.textMuted,
      fontSize: FONT_SIZE.xs,
      fontFamily: 'monospace',
      fontWeight: 700,
      lineHeight: 1.25,
      whiteSpace: 'nowrap',
      ...(variant === 'parchment' ? PARCHMENT : null),
    }}
  >
    {label}
  </kbd>
);
